import { z } from "zod";

/*
 * Need values are now dynamic — populated from the SelfServeProducts table
 * via GET /api/signup/products. The schema validates that at least one need
 * is selected and volumes are filled when the corresponding product is checked,
 * but the specific productKey values are no longer hardcoded.
 */
export const questionnaireSchema = z
  .object({
    needs: z.array(z.string()).min(1, "Select at least one"),
    scrubVolume: z.string().optional(),
    callerIdVolume: z.string().optional(),
    email: z.string().trim(),
  })
  // Email is required to build a plan. On the "Talk to our team first" path it is optional:
  // if given it pre-fills the booking page, if not the visitor just goes there.
  .refine(
    (data) =>
      (data.needs.includes("unsure") && data.email === "") ||
      z.string().email().safeParse(data.email).success,
    { message: "Enter a valid work email", path: ["email"] },
  )
  .refine(
    (data) => {
      if (data.needs.includes("unsure")) return true;
      const needsScrub =
        data.needs.includes("dncscrub") || data.needs.includes("reassigned");
      return !needsScrub || (data.scrubVolume !== undefined && data.scrubVolume !== "");
    },
    {
      message: "Select a scrub volume",
      path: ["scrubVolume"],
    },
  )
  .refine(
    (data) => {
      if (data.needs.includes("unsure")) return true;
      const needsCallerId = data.needs.includes("trustcall");
      return !needsCallerId || (data.callerIdVolume !== undefined && data.callerIdVolume !== "");
    },
    {
      message: "Select a caller ID volume",
      path: ["callerIdVolume"],
    },
  );

export type QuestionnaireForm = z.infer<typeof questionnaireSchema>;
